import { getErrorMessageFromObj } from 'utils/object';
import toast from 'helper/toast';

export const handleActionCb = (cb, cbErr) => (res, err) => {
  if (!res) {
    if (cbErr) cbErr();
    toast.error(getErrorMessageFromObj(err)[0]);
  } else if (cb) cb(res);
};
